// extracted by mini-css-extract-plugin
module.exports = {"logoUploader":"WorkspaceLogoUploader_logoUploader__mcn6w","logoUploader_button":"WorkspaceLogoUploader_logoUploader_button__GZbHQ"};